export default "__VITE_ASSET__G$PcyY4___"